import { useEffect, useState } from 'react';
import { useAddCourtToOrganizerMutation } from '../../Api/courts';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Modal from '../../Style-guide/Modal';
import notify from '../../Style-guide/ToastMessage';

const courtDetails = {
  organizerPhone: '',
  courtName: '',
};

const AddCourtModal = (props) => {
  const { isModalOpen, setIsModalOpen } = props;
  const [courtInputs, setCourtInputs] = useState({ ...courtDetails });
  const { mutate: addCourtRequest, isSuccess } = useAddCourtToOrganizerMutation();

  useEffect(() => {
    if (isSuccess) {
      setCourtInputs({ ...courtDetails });
      setIsModalOpen(false);
    }
    /// disabled to prevent unnecessary modal bug caused by auto filled dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = name === 'organizerPhone' ? formatPhoneNumber(value) : value;

    setCourtInputs((prevFields) => ({
      ...prevFields,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!String(courtInputs.organizerPhone).trim()) {
      notify.info('Phone number is required');

      return;
    }

    addCourtRequest({ data: courtInputs });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <Modal
      show={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      className='add-court-modal'
    >
      <Input
        type='tel'
        name='organizerPhone'
        label={`Organizer's phone number`}
        value={courtInputs.organizerPhone}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Input
        type='text'
        name='courtName'
        label='Court name'
        value={courtInputs.courtName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Button $block className='add-court-btn' onClick={handleSubmit}>
        Submit
      </Button>
    </Modal>
  );
};

export default AddCourtModal;
